import styled from 'styled-components'

import theme, { rem } from '../../../utils/theme'

const StyledDeviceWrap = styled.div`
  width: 100%;
  max-width: ${rem(710)};
  border: ${rem(8)} solid transparent;

  .view-mobile & {
    min-width: ${rem(310)};
    max-width: ${rem(310)};
    border-color: ${theme.colors.navy};
    border-radius: ${rem(30)};
  }
`

const StyledInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: ${rem(4)};
  overflow: hidden;

  .view-mobile & {
    border-radius: ${rem(22)};
  }
`

const StyledToolbar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${rem(18)};
  padding: 0 ${rem(7)};
  background-color: ${theme.colors.midGrey};
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: ${rem(120)};
    height: ${rem(12)};
    transition: ${theme.transitions.smooth};
    transform: translate(-50%, -100%);
    background-color: ${theme.colors.navy};
    border-radius: 0 0 ${rem(18)} ${rem(18)};
    opacity: 0;
  }

  > i {
    width: ${rem(8)};
    height: ${rem(8)};
    border-radius: 100%;
    background-color: ${theme.colors.white};

    & + i {
      margin-left: ${rem(3)};
    }

    &:nth-child(1) {
      background-color: ${theme.colors.red};
    }
    &:nth-child(2) {
      background-color: ${theme.colors.yellow};
    }
    &:nth-child(3) {
      background-color: ${theme.colors.green};
    }

    &:last-child {
      margin-left: auto;
    }
  }

  .view-mobile & {
    height: ${rem(12)};
    background-color: ${theme.colors.white};

    > i {
      opacity: 0;
    }

    &:before {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }
`

const DeviceWrap = ({ children }) => {
  return (
    <StyledDeviceWrap>
      <StyledInner>
        <StyledToolbar>
          <i />
          <i />
          <i />
          <i />
        </StyledToolbar>
        {children}
      </StyledInner>
    </StyledDeviceWrap>
  )
}

export default DeviceWrap
